import { createFileRoute } from "@tanstack/react-router";
import { IntelligencePage } from "@/pages/intelligence/ui/intelligence-page";

type IntelligenceSearch = {
  conversationId?: string;
};

export const Route = createFileRoute("/_authed/$companySlug/intelligence")({
  component: IntelligencePage,
  validateSearch: (search: Record<string, unknown>): IntelligenceSearch => ({
    conversationId:
      typeof search.conversationId === "string"
        ? search.conversationId
        : undefined,
  }),
});
